import { Classes } from "@blueprintjs/core";
import React from "react";
import styled from "styled-components";

import { HexButton, HexButtonProps } from "../../hex-components";

interface LoginOptionProps extends HexButtonProps {
  fillText?: boolean;
  justifyContent?: "center" | "flex-start";
}

interface StyledLoginOptionProps extends HexButtonProps {
  $fillText: boolean;
  $justifyContent: "center" | "flex-start";
}

export const LoginOption = React.forwardRef<
  HTMLButtonElement,
  LoginOptionProps
>(function LoginOption(
  { fillText = false, justifyContent = "center", ...props },
  ref,
) {
  return (
    <StyledLoginOption
      ref={ref}
      $fillText={fillText}
      $justifyContent={justifyContent}
      {...props}
    />
  );
});

const StyledLoginOption = styled(HexButton)<StyledLoginOptionProps>`
  && {
    justify-content: ${({ $justifyContent }) => $justifyContent};
    width: 100%;
  }

  .${Classes.BUTTON_TEXT} {
    width: ${({ $fillText }) => ($fillText ? "100%" : "auto")};

    span {
      font-weight: ${({ theme }) => theme.fontWeight.MEDIUM};
    }
  }
`;
